import { SelectorOption } from 'types/SelectorOption';

export const subcategoryTypes = {
  TRADING_OFFER_OPERATION: {
    IDENTITY_DOCUMENT: 'IDENTITY_DOCUMENT',
    OWNERSHIP_CERTIFICATE: 'OWNERSHIP_CERTIFICATE',
    PAYMENT_JUSTIFICATION: 'PAYMENT_JUSTIFICATION',
    CONTRACT_OR_AGREEMENT: 'CONTRACT_OR_AGREEMENT',
    POWER_OF_ATTORNEY: 'POWER_OF_ATTORNEY',
    OTHER: 'OTRO',
  },
};

export const TRADING_OFFER_OPERATION_DOCUMENT_OPTIONS = [
  {
    value: subcategoryTypes.TRADING_OFFER_OPERATION.IDENTITY_DOCUMENT,
    label: 'DocumentTypeIdentityDocument',
  },
  {
    value: subcategoryTypes.TRADING_OFFER_OPERATION.OWNERSHIP_CERTIFICATE,
    label: 'DocumentTypeOwnershipCertificate',
  },
  {
    value: subcategoryTypes.TRADING_OFFER_OPERATION.PAYMENT_JUSTIFICATION,
    label: 'DocumentTypePaymentJustification',
  },
  {
    value: subcategoryTypes.TRADING_OFFER_OPERATION.CONTRACT_OR_AGREEMENT,
    label: 'DocumentTypeContractOrAgreement',
  },
  {
    value: subcategoryTypes.TRADING_OFFER_OPERATION.POWER_OF_ATTORNEY,
    label: 'DocumentTypePowerOfAttorney',
  },
  {
    value: subcategoryTypes.TRADING_OFFER_OPERATION.OTHER,
    label: 'DocumentTypeOther',
  },
] as SelectorOption[];

export const TRADING_OFFER_OPERATION_DOCUMENT_ACCEPT = '.pdf,.jpg,.jpeg,.png';
export const TRADING_OFFER_OPERATION_DOCUMENT_MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB
